// prod-console (us-east4) → APIs prod-* east4. No DigitalOcean (api.creditotal.online).
// production:false = experimento: backend con PROD=false / sandbox, no corte real.
export const environment = {
  production: false,
  inactive: false,

  BASE_LA: 'https://prod-kredit-api.creditotal.online',
  BASE_RECHARGE: 'https://staging-recharge-api.creditotal.online',
  BASE_FORNT2: 'https://cr-prod-console.creditotal.online',
  BASE_FORNT: 'https://cr-prod-console.creditotal.online',
  redirectRoute: '/console/create-constacts',
  searchClient: '/console/create-constacts',
  psicometrico: '/console/psicometrico',
  initRoute: '/console/search-client',
  BASE_BDV_API: 'https://prod-api-bdv-payment-button.creditotal.online',

  externalPsicometrico: 'https://www.acredita.com.ve:8860/psicometrico/home_test.php',

  loginRoute: '/login',
  logoutRoute: '/logout',

  socketBase: {
    SOCKET_ENDPOINT: 'https://prod-api-socket.creditotal.online/',
  },

  ClieID: '12',
  CED: '11314836',
  IP_LOCAL: '34.181.167.24',
  REWARDS_FRONT_URL: 'https://prod-app-rewards.creditotal.online',

  ONBOARDING_LA: 'https://prod-api-onboarding.creditotal.online',

  ANALYSIS_REPORT: 'https://analysisreport-queue-prod.creditotal.online',

  BASE_CASH_REGISTER_PAYMENT: 'https://prod-api-payment-pos.creditotal.online',

  TRUSTX: 'https://trustx-dev-api.akeela.co',
};
